const WINNIN_WORKSPACES = [
  '01GHVV05EKT91SDDEB57VJP3VZ', // old
  '01GHVVG69C324PQZM9WM4CRJC7', // old
  '01GJ3AKKN2MH9MC16DAE6TWCDW', // old
  '01GPH7RZTSKQTQ3MSTBJ3HW63P', // old
  '01HKWPA4S42VZ9QH99HXCTZ9KA', // BBB 2024
  '01FWM741P0BMVJ26VT4EBRHX6S', // teste WS em dev
]

export default WINNIN_WORKSPACES
